<template>
  <v-container fluid grid-list-sm style="padding: 8px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
        @click:row="selectRow"
        :footer-props="globalFooterOptions"
        :headers="headers"
        :items="items"
        :items-per-page="globalItemsPerPage"
        :loading="loading"
        :options.sync="options"
        :server-items-length="totalItems"
        class="elevation-1"
        style="margin-bottom: 80px;"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn @click.stop="deleteItem(item)" icon><v-icon>delete</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-btn @click="createNew" fab id="addButton" color="success"><v-icon>add</v-icon></v-btn>
  </v-container>

</template>

<script>
import ApiRequests from '@/api/ApiRequests'

export default {
  data () {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      items: [],
      loading: false,
      options: {},
      totalItems: 0
    }
  },

  created () {
    this.getData()
  },

  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    }
  },

  methods: {
    createNew: function () {
      this.$router.push({ name: 'interestdefaultEdit', params: { id: 'new' } })
    },

    getData: function () {
      if (this.options.page !== undefined) {
        this.loading = true

        var params = {}
        if (this.options.itemsPerPage > 0) {
          params.page = this.options.page - 1
          params.limit = this.options.itemsPerPage
        }

        if (this.options.sortBy.length > 0) {
          params.sort = ''
          if (this.options.sortDesc[0]) {
            params.sort = '-'
          }
          params.sort = params.sort + this.options.sortBy[0]
        }

        ApiRequests.interestDefaultQuery(params).then(r => {
          this.items = r.data
          this.totalItems = parseInt(r.headers['x-total-count'])
          this.loading = false
        })
      }
    },

    selectRow: function (item) {
      this.$router.push({ name: 'interestdefaultEdit', params: { id: item._id } })
    }
  }
}
</script>
